/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Goal_CancelInputs */

const en_us2_exercise_personal_goal_cancel = /** @type {(inputs: Exercise_Personal_Goal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const pt_br2_exercise_personal_goal_cancel = /** @type {(inputs: Exercise_Personal_Goal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const es_419_exercise_personal_goal_cancel = /** @type {(inputs: Exercise_Personal_Goal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const pt_pt2_exercise_personal_goal_cancel = /** @type {(inputs: Exercise_Personal_Goal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const fr_fr2_exercise_personal_goal_cancel = /** @type {(inputs: Exercise_Personal_Goal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_de2_exercise_personal_goal_cancel = /** @type {(inputs: Exercise_Personal_Goal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const it_it2_exercise_personal_goal_cancel = /** @type {(inputs: Exercise_Personal_Goal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Exercise_Personal_Goal_CancelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_cancel = /** @type {((inputs?: Exercise_Personal_Goal_CancelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_CancelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_cancel(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_cancel(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_cancel(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_cancel(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_cancel(inputs)
	return en_us2_exercise_personal_goal_cancel(inputs)
});
export { exercise_personal_goal_cancel as "exercise-personal.goal_cancel" }